// 7.2.8 IsRegExp(argument)
var isObject = require('./$.is-object')
  , cof      = require('./$.cof')
  , MATCH    = require('./$.wks')('match');
module.exports = function(it){
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/babel-core/~/core-js/modules/$.is-regexp.js
 ** module id = 249
 ** module chunks = 0
 **/